import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {
  deleteAllLocalStorage,
  getLocalStorage,
  localStorageKey,
} from '../../common/localStorageHandler';
import {routesPath} from '../../router';
import Spinner from 'react-spinner-material';
import logo from '../../assets/logo.svg';
import DashLayout from '../dash-layout/dash-layout';
import './registration.css';
import {
  getSubscriptionDetails,
  getSubscriptionURL,
} from '../../rest-api/chargebee-api/plans';
import ErrorMessage from '../common/errors/error-message';
import Subscription from './subscription';

export default function PlanRegistration(props) {
  const [packageList, setPackageList] = useState([]);
  const [subscribedPackage, setSubscribedPackage] = useState(null);
  const [url, setUrl] = useState('');
  const [errorMessage, setErrorMessage] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getPackageList = () => {
    setErrorMessage('');
    getSubscriptionPage({
      userId: parseInt(getLocalStorage(localStorageKey.USERID)),
      purpose: 'get',
    });
  };

  const getURL = (priceId) => {
    setIsLoading(true);
    setErrorMessage('');
    const jwtToken = getLocalStorage(localStorageKey.JWTTOKEN);
    const apiKeyEureka = getLocalStorage(localStorageKey.APIKEYEUREKA);
    const userId = getLocalStorage(localStorageKey.USERID);

    getSubscriptionURL(apiKeyEureka, jwtToken, priceId, userId)
      .then((res) => {
        if (res.data && res.data.getSubscriptionURL.statusCode == 200) {
          setUrl(res.data.getSubscriptionURL.body.url);
          setIsLoading(false);
        } else if (res.data) {
          setErrorMessage(res.data.getSubscriptionURL.body.message);
          setIsLoading(false);
        } else {
          setErrorMessage(res.errors);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log('Error : ', err);
        setErrorMessage('Server faced an internal Error');
      });
  };

  const getSubscriptionPage = (data) => {
    const jwtToken = getLocalStorage(localStorageKey.JWTTOKEN);
    const apiKeyEureka = getLocalStorage(localStorageKey.APIKEYEUREKA);
    setPackageList([]);
    setSubscribedPackage(null);
    setUrl('');
    setSubscriptionStatus(false);
    getSubscriptionDetails(apiKeyEureka, jwtToken, data)
      .then((res) => {
        console.log('success : ', res);
        if (res.data && res.data.getSubscriptionDetails.statusCode == 200) {
          let packages = JSON.parse(res.data.getSubscriptionDetails.body.data);
          setPackageList(packages);
          if (res.data.getSubscriptionDetails.body.isSubscribed) {
            console.log('Subscription Found');
            console.log(res.data.getSubscriptionDetails.body.planId);
            setSubscribedPackage(res.data.getSubscriptionDetails.body.planId);
            setSubscriptionStatus(true);
            setIsLoading(false);
          } else {
            console.log('No Subscription Found');
          }
        } else if (res.data) {
          setErrorMessage(res.data.getSubscriptionDetails.body.message);
        } else {
          setErrorMessage(res.errors);
        }
      })
      .catch((err) => {
        console.log('Error : ', err);
        setPackageList([]);
        setErrorMessage('Server faced an internal Error');
      });
  };

  const Loader = () => (
    <div className="meal-loader loader-pos">
      {/* <Spinner color="#1a74d4" stroke={4} />
            <br/>
            <br/>
            <br/> */}
      <span>Loading {process.env.REACT_APP_WEBSITE_NAME} Plans...</span>
    </div>
  );

  const SpinLoading = () => (
    <div className="meal-loader loader-pos">
      <Spinner color="#1a74d4" stroke={4} />
    </div>
  );

  const history = useHistory();
  useEffect(() => {
    if (!getLocalStorage(localStorageKey.JWTTOKEN)) {
      history.push(routesPath.SIGN_IN);
    }
    console.log(props.location.search);
    if (props.location.search.length > 0) {
      let params = props.location.search.slice(1).split('&');
      if (params.length > 0) {
        setIsLoading(true);
        getSubscriptionPage({
          userId: parseInt(getLocalStorage(localStorageKey.USERID)),
          subscriptionId: params[0].split('=')[1],
          customerId: params[1].split('=')[1],
          purpose: 'create',
        });
      }
    } else {
      getPackageList();
    }
  }, []);
  return (
    <>
      <DashLayout
        loggedIn={true}
        children={
          isLoading ? (
            <SpinLoading />
          ) : url != '' ? (
            <iframe
              frameBorder="0"
              src={url}
              width="100%"
              height="700"
            ></iframe>
          ) : (
            <div className="parent">
              {packageList.length == 0 && errorMessage.length == 0 ? (
                <Loader />
              ) : (
                packageList.map((value, index) => {
                  console.log(value);
                  return (
                    <div className="card child" key={index}>
                      <div className="container">
                        <div className="top-banner">
                          <h2 className="heading-color">
                            <b>{value.name}</b>
                          </h2>
                          <p className="heading-color">{value.description}</p>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="113"
                              height="33"
                              viewBox="0 0 113 33"
                            >
                              <defs>
                                <linearGradient
                                  id="2lsyfa3d7a"
                                  x1="85.996%"
                                  x2="14.004%"
                                  y1="28.107%"
                                  y2="100%"
                                >
                                  <stop offset="0%" stopColor="#00D0FF" />
                                  <stop offset="100%" stopColor="#1A74D4" />
                                </linearGradient>
                              </defs>
                              <g fill="none" fillRule="evenodd">
                                <path
                                  fill="#000"
                                  fillRule="nonzero"
                                  d="M45.962 27c.265 0 .397-.137.397-.411V25.33c0-.29-.132-.435-.397-.435h-5.417c-.187 0-.28-.08-.28-.242V11.862c0-.274-.132-.411-.397-.411h-1.471c-.265 0-.397.137-.397.411v14.727c0 .274.132.411.397.411h7.565zm4.32-13.977c.25 0 .374-.137.374-.411v-2.2c0-.259-.125-.388-.374-.388h-1.518c-.249 0-.373.13-.373.387v2.2c0 .275.124.412.373.412h1.518zm0 13.977c.14 0 .237-.028.292-.085.054-.056.082-.165.082-.326v-11.51c0-.275-.133-.412-.397-.412h-1.495c-.249 0-.373.137-.373.411v11.51c0 .275.132.412.397.412h1.494zm6.375 0c.28 0 .42-.137.42-.411v-9.625c0-.16.078-.241.233-.241h1.962c.28 0 .42-.137.42-.411v-1.258c0-.258-.14-.387-.42-.387H57.31c-.155 0-.233-.08-.233-.242v-.58c0-.629.113-1.084.338-1.366.226-.282.62-.424 1.18-.424h.7c.265 0 .397-.137.397-.41v-1.258c0-.258-.132-.387-.397-.387h-1.027c-1.137 0-2 .322-2.592.967-.592.645-.887 1.564-.887 2.757v.701c0 .162-.086.242-.257.242h-1.238c-.155 0-.26.028-.315.085-.054.056-.082.157-.082.302v1.258c0 .274.133.41.397.41h1.238c.171 0 .257.081.257.242v9.625c0 .274.132.411.397.411h1.47zm13.31 0c.28 0 .42-.129.42-.387v-1.209c0-.29-.14-.435-.42-.435h-4.718c-1.136 0-1.704-.589-1.704-1.766v-1.04c0-.16.085-.241.257-.241h6.257c.28 0 .42-.145.42-.436v-3.07c0-1.194-.318-2.117-.957-2.77-.638-.652-1.533-.979-2.685-.979h-1.915c-1.151 0-2.043.327-2.673.98-.63.652-.946 1.575-.946 2.768v4.837c0 1.177.315 2.096.946 2.757.63.66 1.522.991 2.673.991h5.044zm-1.986-6.723h-4.18c-.155 0-.233-.08-.233-.241v-1.548c0-.613.132-1.06.397-1.342.265-.282.693-.423 1.284-.423h1.285c.591 0 1.02.14 1.284.423.265.282.397.73.397 1.342v1.548c0 .16-.078.241-.234.241zM81.244 27c.265 0 .397-.137.397-.411V25.33c0-.29-.132-.435-.397-.435h-5.417c-.187 0-.28-.08-.28-.242V11.862c0-.274-.133-.411-.397-.411h-1.471c-.265 0-.397.137-.397.411v14.727c0 .274.132.411.397.411h7.565zm10.741 0c.28 0 .42-.129.42-.387v-1.209c0-.29-.14-.435-.42-.435h-4.717c-1.136 0-1.704-.589-1.704-1.766v-1.04c0-.16.085-.241.257-.241h6.257c.28 0 .42-.145.42-.436v-3.07c0-1.194-.318-2.117-.957-2.77-.638-.652-1.533-.979-2.685-.979h-1.915c-1.151 0-2.043.327-2.673.98-.63.652-.946 1.575-.946 2.768v4.837c0 1.177.315 2.096.946 2.757.63.66 1.522.991 2.673.991h5.044zM90 20.277h-4.18c-.155 0-.233-.08-.233-.241v-1.548c0-.613.132-1.06.397-1.342.265-.282.693-.423 1.284-.423h1.285c.591 0 1.02.14 1.284.423.264.282.397.73.397 1.342v1.548c0 .16-.078.241-.234.241zM99.364 27c1.198 0 1.984-.427 2.358-1.282h.093v.87c0 .275.133.412.397.412h1.471c.28 0 .42-.137.42-.411v-11.51c0-.275-.14-.412-.42-.412h-5.23c-1.152 0-2.043.327-2.674.98-.63.652-.945 1.575-.945 2.768v4.837c0 1.177.315 2.096.945 2.757.63.66 1.522.991 2.674.991h.91zm.537-2.055H98.78c-1.12 0-1.681-.597-1.681-1.79v-4.643c0-1.193.56-1.79 1.68-1.79h2.78c.17 0 .256.081.256.242v5.925c0 1.37-.638 2.056-1.914 2.056zM109.965 27c.28 0 .42-.137.42-.411v-9.625c0-.16.078-.241.233-.241h1.962c.28 0 .42-.137.42-.411v-1.258c0-.258-.14-.387-.42-.387h-1.962c-.155 0-.233-.08-.233-.242v-.58c0-.629.113-1.084.338-1.366.226-.282.62-.424 1.18-.424h.7c.265 0 .397-.137.397-.41v-1.258c0-.258-.132-.387-.397-.387h-1.027c-1.137 0-2 .322-2.592.967-.592.645-.887 1.564-.887 2.757v.701c0 .162-.086.242-.257.242h-1.238c-.156 0-.26.028-.315.085-.055.056-.082.157-.082.302v1.258c0 .274.132.41.397.41h1.238c.17 0 .257.081.257.242v9.625c0 .274.132.411.396.411h1.472z"
                                />
                                <path
                                  fill="url(#2lsyfa3d7a)"
                                  d="M20.698 8.027c4.032 0 7.304 2.978 7.302 7.79 0 2.868-2.247 6.119-4.038 7.708 0 0-5.856 4.256-9.962 9.475-1.028-1.79-4.613-5.292-10.755-10.505C1.457 20.908 0 18.685 0 15.818c0-4.813 3.27-7.791 7.306-7.791 3 0 5.57 1.235 6.694 4.32 1.125-3.084 3.698-4.32 6.698-4.32zm-7.551 5.7l-1.186 6.787-9.443.352 9.956 1.108.673-1.912 1.428 6.313 1.911-5.18 5.99-.329 3.738-.352-10.77-.462-.473 1.458-1.824-7.782zM17.5 0c-.073 2.82-.306 4.758-.698 5.813-.393 1.054-1.22 2.387-2.481 3.998-.472-1.933-.423-3.812.144-5.635S16.044.961 17.5 0z"
                                />
                              </g>
                            </svg>
                          </div>
                          <div className="price-tag">
                            Starts from {value.currency}{' '}
                            {(value.price / 100).toFixed(2)}
                          </div>
                        </div>
                        <div className="text-center btnDiv">
                          {subscriptionStatus &&
                          subscribedPackage == value.priceId ? (
                            <div>
                              <span>&#10003;</span> Subscribed
                            </div>
                          ) : (
                            <button
                              className="btn btn-primary"
                              onClick={() => getURL(value.priceId)}
                            >
                              Subscribe
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
              {errorMessage.length > 0 && (
                <ErrorMessage classes="w-100" message={errorMessage} />
              )}
            </div>
          )
        }
      />
    </>
  );
}
